{
  "name": "Pedal Harp Layout 12edo",
  "description": "22-tone layout for testing harp pedal combinations.",
  "scale": [
    "1\\12",
    "0\\12",
    "1\\12",
    "2\\12",
    "3\\12",
    "4\\12",
    "3\\12",
    "4\\12",
    "5\\12",
    "6\\12",
    "5\\12",
    "6\\12",
    "7\\12",
    "8\\12",
    "8\\12",
    "8\\12",
    "9\\12",
    "10\\12",
    "11\\12",
    "10\\12",
    "11\\12",
    "2/1"
  ],
  "key_colors_mode": "manual",
  "short_description": "HarpLayout",
  "built_in_group": "Scordatura",
  "key_labels": "note_names",
  "fundamental_color": "#ffdbe8",
  "note_names": [
    "C",
    "D",
    "B",
    "C",
    "D",
    "E",
    "F",
    "D",
    "E",
    "F",
    "G",
    "E",
    "F",
    "G",
    "A",
    "",
    "G",
    "A",
    "B",
    "C",
    "A",
    "B"
  ],
  "note_colors": [
    "#ffadad",
    "d0d0d7",
    "dee2da",
    "dee2da",
    "ffffff",
    "d0d0d7",
    "d0d0d7",
    "dee2da",
    "ffffff",
    "ffffff",
    "d0d0d7",
    "dee2da",
    "dee2da",
    "ffffff",
    "d0d0d7",
    "999999",
    "dee2da",
    "ffffff",
    "d0d0d7",
    "d0d0d7",
    "dee2da",
    "ffffff"
  ],
  "equivSteps": 22,
  "fundamental": 440,
  "reference_degree": 17,
  "center_degree": 0,
  "rSteps": 7,
  "drSteps": 4,
  "hexSize": 42,
  "rotation": -16.102113751,
  "lumatone_anchor_note": 27,
  "lumatone_anchor_channel": 3
}
